// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_a32181f","icon":"_c1dc1d0","loader":"_32ebccf","tooltip":"_6f142f4","tooltipWrapper":"_ccc6a4a","tooltipClubDescription":"_e776b52"};